module.exports = __webpack_public_path__ + "static/media/LeftNav_Icon_Courses.1ca144b2.svg";